export const NAME_PLACEHOLDER = '...';
export const DEFAULT_PAGE_SIZE = 100;
